import React from 'react';
import { Typography } from '@mui/material';
import { withStyles } from 'tss-react/mui';

const styles = theme => ({
    proLabelRight: {
        opacity: 0.8,
        position: 'absolute',
        textAlign: 'end',
        paddingTop: 5,
        fontWeight: 'bold'
    },
    proLabelLeft: {
        opacity: 0.8,
        position: 'absolute',
        textAlign: 'start',
        paddingTop: 5,
        paddingLeft: 10,
        fontWeight: 'bold'
    }
});

const defaultAlign = "end";

const ProMediaCardLabel = (props) => {
    const { classes, width, align } = props;
    const alignLabel = align || defaultAlign;

    return (
        <Typography
            className={alignLabel == "end" ? classes.proLabelRight : classes.proLabelLeft}
            style={{ width: width }}
        >
            Pro
        </Typography>
    );
};

export default withStyles(ProMediaCardLabel, styles);